/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2025-03-06 14:58:24
 * @LastEditors: Junteng Shi
 * @LastEditTime: 2025-05-19 17:12:40
 */
// import ErrorPage from '@/views/error/404.vue';
// import Layout from '@/layout/index.vue';
export default [
  {
    path: '/login',
    name: 'index',
    meta: {
      title: '登录',
    },
    component: () => import('@/views/login/index.vue'),
  },
  // {
  //   path: '/',
  //   name: 'layout',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/teacher',
  //       name: 'teacher',
  //       meta: {
  //         title: '教师管理',
  //       },
  //       component: () => import('@/views/teacher/index.vue'),
  //     },
  //     {
  //       path: '/school',
  //       name: 'school',
  //       meta: {
  //         title: '学校管理',
  //       },
  //       component: () => import('@/views/school/index.vue'),
  //     },
  //     {
  //       path: '/class',
  //       name: 'class',
  //       meta: {
  //         title: '班级管理',
  //       },
  //       component: () => import('@/views/class/index.vue'),
  //     },
  //     {
  //       path: '/students',
  //       name: 'students',
  //       meta: {
  //         title: '学生管理',
  //       },
  //       component: () => import('@/views/students/index.vue'),
  //     },
  //     {
  //       path: '/permissions',
  //       name: 'permissions',
  //       meta: {
  //         title: '权限管理',
  //       },
  //       component: () => import('@/views/permissions/index.vue'),
  //     },
  //     {
  //       path: '/bigData',
  //       name: 'bigData',
  //       meta: {
  //         title: '大数据管理',
  //       },
  //       component: () => import('@/views/bigData/index.vue'),
  //     },
  //     // 重定向到teacher
  //     {
  //       path: '/',
  //       redirect: '/school',
  //     }
  //   ],
  // },
  // {
  //   path: '/:pathMatch(.*)*',
  //   name: '404',
  //   component: ErrorPage,
  //   meta: {
  //     title: '无法找到该页面',
  //     layout: false,
  //   },
  // },
];
